<mat-form-field class="fd-input__container" color="accent" [subscriptSizing]="field?.hint ? 'dynamic' : 'fixed'">
  <mat-label>{{ field?.label }}</mat-label>
  <div [formGroup]="parentForm" class="fd-input__field-container">
    <input
      matInput
      [style.text-transform]="field?.transform === 'UPPERCASE' ? 'uppercase' : null"
      [formControlName]="field?.controlName"
      autocomplete="off"
      class="fd-input__field"
      [maxlength]="field?.maxLength"
      [mask]="maskExpression"
      [patterns]="resolvedPatterns"
      [id]="resolvedInputId"
      [required]="required || null"
      aria-label="Area code"
      [type]="field?.type || 'text'"
      autocomplete="off"
      [attr.disabled]="field?.disabled || null"
      tabindex="0"
      (blur)="handleBlur($event)"
      (input)="handleChange($event)"
      (paste)="pasteHandle($event)"
    />
  </div>
  <mat-icon matSuffix class="fd-input__icon-container" *ngIf="hasIcon" [innerHTML]="field?.iconHTML"> </mat-icon>
  <fa-icon
    *ngIf="field?.tooltipMessage"
    matTooltipClass="fd-input__tooltip-dialog"
    class="fd-input__tooltip-icon"
    icon="info-circle"
    size="1x"
    mat-button
    [matTooltip]="field?.tooltipMessage"
    (mouseenter)="$event.stopImmediatePropagation()"
    (mouseleave)="$event.stopImmediatePropagation()"
    #tooltip="matTooltip"
    tabindex="0"
    (click)="showTooltipAndStopPropagation()"
    (keydown.enter)="showTooltipAndStopPropagation()"
  >
  </fa-icon>
  <mat-hint class="fd-input__hint">{{ field?.hint }}</mat-hint>
  <mat-error class="fd-input__error" *ngIf="hasError">
    <div *ngFor="let errorMessage of errorMessages">{{ errorMessage }}</div>
  </mat-error>
</mat-form-field>
